import classNames from 'classnames'
import React, { CSSProperties, forwardRef, HTMLAttributes } from 'react'

import { Slot } from '../utilities'
import styles from './skeleton.module.scss'

type SkeletonStyleProps = Pick<
  CSSProperties,
  'height' | 'maxHeight' | 'minHeight' | 'width' | 'maxWidth' | 'minWidth'
>

export const SkeletonRadiusValues = ['xs', 'sm', 'md', 'lg', 'pill', 'circle'] as const
export type SkeletonRadius = (typeof SkeletonRadiusValues)[number]

export type SkeletonElement = HTMLDivElement
export type SkeletonProps = HTMLAttributes<SkeletonElement> &
  SkeletonStyleProps & {
    asChild?: boolean
    radius?: SkeletonRadius
  }

const inert = parseFloat(React.version) >= 19 || undefined

export const Skeleton = forwardRef<SkeletonElement, SkeletonProps>(function Skeleton(
  props,
  forwardedRef
) {
  const {
    height,
    width,
    maxWidth,
    minWidth,
    minHeight,
    maxHeight,
    radius: borderRadius,
    className,
    style: styleProp,
    asChild,
    ...rest
  } = props

  const style = {
    ...styleProp,
    height,
    width,
    maxWidth,
    minWidth,
    minHeight,
    maxHeight,
    // priority to radius prop (already defined in className)
    borderRadius: undefined,
  }
  const classes = classNames(
    styles.root,
    {
      [styles[`r${borderRadius}`]]: borderRadius,
    },
    className
  )

  const Component = asChild ? Slot : 'div'
  return (
    <Component
      {...rest}
      className={classes}
      style={style}
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      inert={inert}
      aria-hidden
      ref={forwardedRef}
    />
  )
})
